export const STATUTS_DEMANDE_RDV = ["BROUILLON", "EN_ATTENTE", "CONFIRME", "REFUSE", "EXPIRE", "ANNULE"];
export const LIEUX_RDV = [
  ["MAGASIN", "Magasin"], ["CLUB", "Chez le club"], ["TELEPHONE", "Téléphone"],
  ["VISIO", "Visio"], ["AUTRE", "Autre"]
];

export function minutesDuree(valeur, personnalisee = 90) {
  if (valeur === "30min") return 30;
  if (valeur === "1h") return 60;
  return Math.max(15, Math.min(480, Number(personnalisee) || 60));
}

export function finCreneau(debut, dureeMinutes) {
  const date = new Date(debut);
  if (Number.isNaN(date.valueOf())) return "";
  return new Date(date.getTime() + dureeMinutes * 60000).toISOString();
}

export function normaliserCreneaux(creneaux, dureeMinutes) {
  return (creneaux || []).filter((item) => item?.debut).map((item) => ({ debut: new Date(item.debut).toISOString(), fin: finCreneau(item.debut, dureeMinutes) }));
}

export function chevauche(debutA, finA, debutB, finB) {
  return new Date(debutA) < new Date(finB) && new Date(debutB) < new Date(finA);
}

function dureePlanningMinutes(action) {
  const valeurs = { "30min": 30, "1h": 60, "2h": 120, "3h": 180, "demi-journee": 240, journee: 1440 };
  return valeurs[action?.duree_rdv] || 60;
}

export function conflitsPlanning(creneaux, actions, commercial, dureeMinutes) {
  const normalises = normaliserCreneaux(creneaux, dureeMinutes);
  return normalises.map((creneau, index) => {
    const conflit = (actions || []).find((action) => {
      if (String(action.commercial || "").toLocaleLowerCase("fr") !== String(commercial || "").toLocaleLowerCase("fr")) return false;
      if (!action.date_rdv) return false;
      const debut = new Date(`${action.date_rdv}T${String(action.heure_rdv || "00:00").slice(0, 5)}:00`);
      return chevauche(creneau.debut, creneau.fin, debut, new Date(debut.getTime() + dureePlanningMinutes(action) * 60000));
    });
    return conflit ? { index, action: conflit } : null;
  }).filter(Boolean);
}

export function libelleDuree(minutes) {
  if (minutes === 30) return "30 min";
  if (minutes === 60) return "1 h";
  const heures = Math.floor(minutes / 60);
  const reste = minutes % 60;
  return `${heures ? `${heures} h` : ""}${reste ? ` ${reste} min` : ""}`.trim();
}

export function lienPublicRdv(token, origine = window.location.origin) {
  return `${String(origine).replace(/\/$/, "")}/?rdv=${encodeURIComponent(token)}`;
}

export function apercuEmailRdv({ club, contact, commercial, objet, dureeMinutes, lieu, creneaux, lien }) {
  const nom = contact?.nom || "Madame, Monsieur";
  const lignes = normaliserCreneaux(creneaux, dureeMinutes).map((item) => `• ${new Date(item.debut).toLocaleString("fr-FR", { dateStyle: "full", timeStyle: "short" })}`);
  return {
    sujet: `Proposition de rendez-vous — ${objet}`,
    corps: `Bonjour ${nom},\n\n${commercial} vous propose un rendez-vous pour ${club?.nom || "votre club"}.\nObjet : ${objet}\nDurée : ${libelleDuree(dureeMinutes)}\nLieu : ${lieu}\n\nCréneaux proposés :\n${lignes.join("\n")}\n\nChoisir un créneau ou refuser : ${lien}\n\nCordialement,\n${commercial}`
  };
}

export function peutGererRdv(utilisateur) {
  return ["commercial", "superviseur", "gestionnaire", "admin", "admin_groupe"].includes(String(utilisateur?.role || "").toLowerCase());
}

export function ajouterHistoriqueReport(meta, ancienneDate, nouvelleDate, acteur, raison = "") {
  return { ...meta, historique: [...(Array.isArray(meta?.historique) ? meta.historique : []), { type: "REPORT", ancienne_date: ancienneDate, nouvelle_date: nouvelleDate, acteur, raison, date: new Date().toISOString() }] };
}
